import React from 'react';


const FeedbacksContext = React.createContext();

export default FeedbacksContext;
